import { createNode, TemporalValueUnion } from '@glueapp/graph-types';
import { formatTemporalPattern } from '../../utils/formatTemporal';

export const FormatDateTimePattern = createNode({
    id: 'Format Date/Time',
    name: 'Format Date/Time',
    description: 'Formats a date/time value using a custom pattern (e.g. yyyy-MM-dd HH:mm:ss)',
    aiDescription:
        'Takes a temporal value (Date, Time, DateTime, or ZonedDateTime) on the "Value" port and formats it as a string on the "Text" port using a custom pattern configured in node state.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Value: { kind: 'generic', identifier: 'T', extends: TemporalValueUnion },
    },
    outPorts: {
        Text: { kind: 'string' },
    },
    interfaceComponentId: 'datetime-format-editor',
    execute: function (input) {
        const pattern = (input.state.formatPattern as string) || 'yyyy-MM-dd HH:mm:ss';
        const formatted = formatTemporalPattern(input.inPorts.Value, pattern);
        return { output: { Text: formatted } };
    },
});
